import { FacturacionEstado } from 'src/utils/enums/FacturacionEstado';
import { FacturacionFormState } from './types';
import { colorMapping } from 'src/utils/enums/FacturacionEstado';

import {
  marcarEnviadaFacturacionF,
  marcarPagadaFacturacionF,
  marcarAdeudadaFacturacionF,
} from './apiThunk';
import { RootState } from 'src/app/store';
import { createSlice } from '@reduxjs/toolkit';

const initialState: FacturacionFormState = {
  data: null,
  status: null,
  actions: null,
  previousState: undefined,
  productos: null,
};

const formSlice = createSlice({
  name: 'facturacionForm',
  initialState,
  reducers: {
    resetForm(state) {
      state.data = null;
      state.status = null;
      state.actions = null;
      state.previousState = null;
    },

    setFormStatusBorrador(state) {
      state.status = {
        id: FacturacionEstado.Borrador,
        text: FacturacionEstado[FacturacionEstado.Borrador].toUpperCase(),
        color: colorMapping[FacturacionEstado.Borrador],
      };
      state.actions = {
        guardar: {
          visible: true,
          disabled: false,
          tooltip: 'Guardar',
        },

        marcarEnviadaFacturacionF: {
          visible: true,
          disabled: false,
          tooltip: 'Enviar facturación',
        },
        marcarPagadaFacturacionF: {
          visible: true,
          disabled: false,
          tooltip: 'Marcar pagada la facturación',
        },
        marcarAdeudadaFacturacionF: {
          visible: true,
          disabled: false,
          tooltip: 'Marcar adeudada la facturación',
        },
      };
      state.data = {
        actividadId: { readOnly: false },
        clienteId: {
          readOnly: true,
          placeholder: 'Se autocompleta al seleccionar Orden',
        },
        concepto: { readOnly: false },
        estado: { readOnly: true },
        fechaEmision: { readOnly: false },
        fechaPago: { readOnly: false },
        fechaVtoPago: { readOnly: false },
        importeNeto: { readOnly: false },
        iva: { readOnly: false },
        monedaArsUsd: { readOnly: false },
        monedaExtranjera: { readOnly: false },
        monedaId: { readOnly: false },
        nro: { readOnly: true },
        nroOcCliente: {
          readOnly: true,
          placeholder: 'Se autocompleta al seleccionar Orden',
        },
        nroProveedor: {
          readOnly: true,
          placeholder: 'Se autocompleta al seleccionar Orden',
        },
        ordenId: { readOnly: false },
        puntoDeVentaId: { readOnly: false },
        tipoComprobanteId: { readOnly: false },
        total: { readOnly: false },
      };
    },
    setFormStatusEnviada(state) {
      state.status = {
        id: FacturacionEstado.Enviada,
        text: FacturacionEstado[FacturacionEstado.Enviada].toUpperCase(),
        color: colorMapping[FacturacionEstado.Enviada],
      };
      state.actions = {
        guardar: {
          visible: false,
          disabled: true,
          tooltip: 'Guardar',
        },

        marcarEnviadaFacturacionF: {
          visible: false,
          disabled: true,
          tooltip: 'Enviar facturación',
        },
        marcarPagadaFacturacionF: {
          visible: true,
          disabled: false,
          tooltip: 'Marcar pagada la facturación',
        },
        marcarAdeudadaFacturacionF: {
          visible: true,
          disabled: false,
          tooltip: 'Marcar adeudada la facturación',
        },
      };
    },
    setFormStatusPagada(state) {
      state.status = {
        id: FacturacionEstado.Pagada,
        text: FacturacionEstado[FacturacionEstado.Pagada].toUpperCase(),
        color: colorMapping[FacturacionEstado.Pagada],
      };
      state.actions = {
        guardar: {
          visible: true,
          disabled: false,
          tooltip: 'Guardar',
        },

        marcarEnviadaFacturacionF: {
          visible: true,
          disabled: false,
          tooltip: 'Enviar facturación',
        },
        marcarPagadaFacturacionF: {
          visible: true,
          disabled: false,
          tooltip: 'Marcar pagada la facturación',
        },
        marcarAdeudadaFacturacionF: {
          visible: true,
          disabled: false,
          tooltip: 'Marcar adeudada la facturación',
        },
      };
    },
    setFormStatusAdeudada(state) {
      state.status = {
        id: FacturacionEstado.Adeudada,
        text: FacturacionEstado[FacturacionEstado.Adeudada].toUpperCase(),
        color: colorMapping[FacturacionEstado.Adeudada],
      };
      state.actions = {
        guardar: {
          visible: true,
          disabled: false,
          tooltip: 'Guardar',
        },

        marcarEnviadaFacturacionF: {
          visible: true,
          disabled: false,
          tooltip: 'Enviar facturación',
        },
        marcarPagadaFacturacionF: {
          visible: true,
          disabled: false,
          tooltip: 'Marcar pagada la facturación',
        },
        marcarAdeudadaFacturacionF: {
          visible: true,
          disabled: false,
          tooltip: 'Marcar adeudada la facturación',
        },
      };
    },
    setModifyingProducts(state) {
      state.previousState = {
        status: state.status,
        actions: state.actions,
      };

      state.actions = {
        guardar: {
          visible: true,
          disabled: true,
          tooltip: 'Guardar',
        },

        marcarEnviadaFacturacionF: {
          visible: true,
          disabled: true,
          tooltip: 'Enviar facturación',
        },
        marcarPagadaFacturacionF: {
          visible: true,
          disabled: true,
          tooltip: 'Marcar pagada la facturación',
        },
        marcarAdeudadaFacturacionF: {
          visible: true,
          disabled: true,
          tooltip: 'Marcar adeudada la facturación',
        },
      };
    },
    setModifyingProductsFinished(state) {
      // Restaurar estado anterior
      state.status = state.previousState!.status;
      state.actions = state.previousState!.actions;
      state.previousState = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(marcarEnviadaFacturacionF.fulfilled, (state, action) => {
      console.log(
        'Completar con la lógica correspondiente a la acción exitosa.'
      );
    });
    builder.addCase(marcarEnviadaFacturacionF.rejected, (state, action) => {
      console.log(
        'Completar con la lógica correspondiente a la acción fallida.'
      );
    });

    builder.addCase(marcarPagadaFacturacionF.fulfilled, (state, action) => {
      console.log(
        'Completar con la lógica correspondiente a la acción exitosa.'
      );
    });
    builder.addCase(marcarPagadaFacturacionF.rejected, (state, action) => {
      console.log(
        'Completar con la lógica correspondiente a la acción fallida.'
      );
    });

    builder.addCase(marcarAdeudadaFacturacionF.fulfilled, (state, action) => {
      console.log(
        'Completar con la lógica correspondiente a la acción exitosa.'
      );
    });
    builder.addCase(marcarAdeudadaFacturacionF.rejected, (state, action) => {
      console.log(
        'Completar con la lógica correspondiente a la acción fallida.'
      );
    });
  },
});
// Selectors

export const selectFormStatus = (state: RootState) =>
  state.facturacion.form.status;

export const selectMarcarEnviadaFacturacionF = (state: RootState) =>
  state.facturacion.form.actions?.marcarEnviadaFacturacionF;

export const selectMarcarPagadaFacturacionF = (state: RootState) =>
  state.facturacion.form.actions?.marcarPagadaFacturacionF;

export const selectMarcarAdeudadaFacturacionF = (state: RootState) =>
  state.facturacion.form.actions?.marcarAdeudadaFacturacionF;

export const selectGuardar = (state: RootState) =>
  state.facturacion.form.actions?.guardar;

// Export actions
export const {
  resetForm,

  setFormStatusBorrador,
  setFormStatusEnviada,
  setFormStatusPagada,
  setFormStatusAdeudada,
  setModifyingProducts,
  setModifyingProductsFinished,
} = formSlice.actions;

export default formSlice.reducer;
